import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import S3FileUpload from "react-s3";
import Swal from "sweetalert2";
import Switch from "react-switch";

import Avatar from "../../assets/images/users/profile.png";
import Loading from "../../components/Common/Loading";

function Profile() {
  const [image, setImage] = useState(null);
  const [secure, setSecure] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.User);
  const dispatch = useDispatch();

  //   console.log("Profile>>>", user?.user);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  // Get user details
  const getUserDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_USER_PROFILE + user?.user?._id, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success) {
          setImage(res.data.image);
          setSecure(res.data.auth2fa);
          setValue("name", res.data.name);
          setValue("email", res.data.email);
          setValue("mobile", res.data.mobile);
          setValue("role", res.data.role ? res.data.role.title : res.data.role);
          setValue("facebook", res.data.facebook);
          setValue("twitter", res.data.twitter);
          setValue("instagram", res.data.instagram);
          setValue("linkedin", res.data.linkedin);
          setValue("youtube", res.data.youtube);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  // Todo: onSubmit
  const onSubmit = (data) => {
    setIsLoading(true);
    apiReq(
      url.UPDATE_USER_PROFILE + user?.user?._id,
      {
        name: data.name,
        mobile: data.mobile,
        facebook: data.facebook,
        twitter: data.twitter,
        instagram: data.instagram,
        linkedin: data.linkedin,
        youtube: data.youtube,
        image: image,
        auth2fa: secure,
      },
      "put",
      {
        Authorization: `Bearer ${user.user?.token}`,
      }
    )
      .then((res) => {
        if (res.success) {
          Swal.fire({
            title: "Success",
            text: "Profile updated successfully.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          dispatch({ type: "USER_UPDATE", payload: res.data });
          localStorage.setItem("infoSalonsUser", JSON.stringify(res.data));
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  // AWS Config
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "users",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // HandleImageUpload
  const uploadImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // handleChangeSecure
  const handleChangeSecure = (e) => {
    setSecure(e);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Profile</h5>
                </div>
              </div>
              <hr />
              <div className="d-flex mt-3">
                <div className="profile_pic_wrapper">
                  <div className="user_img_wrapper">
                    {image ? (
                      <img src={image} alt={user?.user?.name} />
                    ) : (
                      <img src={Avatar} alt={user?.user?.name} />
                    )}
                    <div className="overlay">
                      <div className="inner">
                        <i className="ri-image-line"></i>
                        Change
                      </div>
                      <input
                        type="file"
                        className="upload_hidden"
                        accept="image/png, image/gif, image/jpeg"
                        onChange={(e) => uploadImage(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="profile_details_wrapper">
                  <h4 style={{ marginBottom: -10 }}>Security Info</h4>
                  <hr />
                  <div className="row">
                    <div className="col-md-3">
                      <strong style={{ position: "relative", top: 4 }}>
                        2FA Authentication
                      </strong>
                    </div>
                    <div className="col-md-9">
                      <Switch
                        value={secure}
                        onChange={handleChangeSecure}
                        checked={secure}
                      />
                    </div>
                  </div>
                  <h4 style={{ marginBottom: -10 }} className="mt-3">
                    Personal Info
                  </h4>
                  <hr />
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        {...register("name", { required: true })}
                      />
                      {errors.name && (
                        <span className="text-danger">Name is required.</span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        disabled
                        {...register("email", { required: false })}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Mobile</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Mobile No."
                        {...register("mobile", { required: false })}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Role</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Role"
                        disabled
                        {...register("role", { required: false })}
                      />
                    </div>
                    <div className="mt-4 mb-2">
                      <h4 style={{ marginBottom: -10 }}>Social Links</h4>
                      <hr />
                    </div>
                    <div className="mb-3">
                      <label>Facebook</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter facebook profile link"
                        {...register("facebook", { required: false })}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Twitter</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter twitter profile link"
                        {...register("twitter", { required: false })}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Linkedin</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter linkedin profile link"
                        {...register("linkedin", { required: false })}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Instagram</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter instagram profile link"
                        {...register("instagram", { required: false })}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Youtube</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter youtube profile link"
                        {...register("youtube", { required: false })}
                      />
                    </div>
                    <hr />
                    <div className="mb-2">
                      <button className="btn btn-primary" type="submit">
                        Update profile
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Profile;
